import React, { Component } from 'react'
import QrReader from 'react-qr-scanner'

import './QbQrScanner.css'

class QbQrScanner extends Component {

  state = {
    showQrReader: false
  }

  renderRequiredMessage() {
    const { errorMessage } = this.props
    if (errorMessage) {
      return (
        <div className={`qb-qr-reader-error-text ${getTextErrorClass(errorMessage)}`}>
          {errorMessage}
        </div>
      )
    }
    return null
  }

  render() {
    const { title, style, errorMessage, onScan, onError } = this.props

    return (
      <div style={style} className={`qb-qr-reader-container ${getContainerErrorClass(errorMessage)}`}>
        <div style={{ display: 'flex', flexDirection: 'column-reverse' }}>
          <QrReader
            className={`qb-qr-reader-container ${getContainerErrorClass(errorMessage)}`}
            delay={500}
            onError={onError}
            onScan={onScan}
            style={getQrReaderStyle(errorMessage)}
            showViewFinder={false}
          />
          <label className="shared-label-text qb-qr-reader-label-text">{title}</label>
        </div>
        { this.renderRequiredMessage() }
      </div>
    )
  }
}

export default QbQrScanner


const getContainerErrorClass = errorMessage => errorMessage ? 'qb-qr-reader-container--error' : ''

const getQrReaderStyle = errorMessage => errorMessage ? QR_READER_ERROR_STYLE : QR_READER_STYLE

const getTextErrorClass = errorMessage => errorMessage ? 'qb-qr-reader-error-text--error' : ''

const QR_READER_STYLE = {
    width: '100%',
    height: '155px',
    border: 'solid #5F5F5F 1px',
    borderRadius: 5,
    objectFit: 'cover',
    color: `var(--qb-gray-color)`,
}

const QR_READER_ERROR_STYLE = {
    width: '100%',
    height: '155px',
    border: 'solid var(--warning-color) 1px',
    borderRadius: 5,
    objectFit: 'cover'
}


// WEBPACK FOOTER //
// ./src/components/shared/QbQrScanner/QbQrScanner.js